import { useRouter } from 'next/router';

// TODO: add some proper URI manipulation lib
export const useVariantNavigation = () => {
  const { push, asPath } = useRouter();

  const actualPath = asPath.split('?')[0];

  return (modelId: number | string) =>
    push(`${actualPath}?model_id=${modelId}`, undefined, {
      shallow: false,
      scroll: false,
    });
};
